import React, { useState } from "react";
import { CgSpinner } from "react-icons/cg";
import { CiEdit } from "react-icons/ci";
import { MdDeleteOutline } from "react-icons/md";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { checkAccessFn } from "../../../../utils/checkAccess";
import LoadingWithLable from "../../../../ReusableComponents/Loading/LoadingWithLable";

import useSearchPagination from "../../../../ReusableComponents/SearchPagination/useSearchPagination";
import { axios } from "../../../../Global";
import { setAppError } from "../../../../store/userSlice";
import Highlighter from "react-highlight-words";

export default function ListDataQuotation({
  list = [],
  editData,
  deleteData,
  loading,
  titles = [],
  contractModalHandler,
  addData,
}) {
  const token = localStorage.getItem("token");
  const dispatch = useDispatch();
  const dashboardData = useSelector((state) => state.dashboardData);
  const [downloadLoading, setDownloadLoading] = useState(false);

  const downloadFile = async () => {
    setDownloadLoading(true);
    try {
      const response = await axios.get(`/dashboard/quotation-download/excel`, {
        responseType: "blob",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.status === 200) {
        const url = window.URL.createObjectURL(response.data);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `Quotation`);
        document.body.appendChild(link);
        link.click();
        dispatch(
          setAppError({
            msg: "Excel Downloaded",
            color: "success",
          })
        );
        setDownloadLoading(false);
      } else {
        throw new Error("Something went wrong!");
      }
    } catch (err) {
      setDownloadLoading(false);
      dispatch(
        setAppError({
          msg: err.message,
        })
      );
    }
  };

  const checkAccess = (module, name) => {
    return checkAccessFn(dashboardData, module, name);
  };
  const {
    NoDataFound,
    Pagination,
    PaginationIndex,
    Search,
    CountPerPage,
    currentList,
  } = useSearchPagination(list?.data);

  const [searchWords, setSearchWords] = useState([]);
  return (
    <>
      <div className="pt-2">
        <div className="flex flex-wrap gap-2 mb-1 items-center">
          {checkAccess("Quotation", "quotation-create") && (
            <Link to="/dashboard/quotation/create">
              <button
                className="p-2 bg-red text-white rounded-md"
                onClick={addData}
              >
                Add New Quotation +
              </button>
            </Link>
          )}
          <Search
            keywords={[
              "name",
              "quotation_number",
              "client.name",
              "quotation_type.name",
              "status",
              "user.name",
              "user.email",
              "created_at",
            ]}
            setSearchWords={setSearchWords}
          />
          <button
            className="p-2 px-4 rounded-md bg-blue disabled:bg-gray text-white min-w-fit text-sm flex items-center gap-2"
            onClick={() => downloadFile()}
            disabled={downloadLoading || list?.isLoading}
          >
            <p>Download</p>
            {downloadLoading && <CgSpinner className="animate-spin" />}
          </button>
        </div>
        <p className="text-sm w-full text-right font-medium mb-1  block">{`Slide / scroll to right >`}</p>
        <CountPerPage />
        <div className="w-full overflow-auto max-h-[700px]">
          <div className="grid grid-cols-table-quotation auto-cols-min gap-5 p-6 bg-white w-full rounded-md items-baseline">
            {/* Headers with Sticky */}
            {titles.map((title, index) => (
              <p
                key={index}
                className="font-semibold uppercase bg-white sticky top-0 z-10 p-2"
              >
                {title}
              </p>
            ))}

            {/* Data Content */}
            {list?.isLoading && <LoadingWithLable className="col-span-11" />}
            <NoDataFound />

            {!list?.isLoading &&
              currentList?.map((listItem, index) => (
                <React.Fragment key={index}>
                  <PaginationIndex index={index} />

                  <p className="text-left">
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape
                      textToHighlight={listItem?.quotation_number || "-"}
                    />
                  </p>

                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape
                      textToHighlight={listItem?.name || "-"}
                    />
                  </p>

                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape
                      textToHighlight={listItem?.client?.name || "-"}
                    />
                  </p>

                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape
                      textToHighlight={listItem?.quotation_type?.name || "-"}
                    />
                  </p>

                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape
                      textToHighlight={listItem?.status || "-"}
                    />
                  </p>
                  {checkAccess("Quotation", "quotation-cost-sheet-list") &&
                  listItem.quotation_cost_sheet_cost_detail.length > 0 ? (
                    // &&l?.quotation_type?.name !== "Hourly"
                    <Link
                      to={`/dashboard/quotation/${listItem.id}`}
                      state={{
                        quotationId: listItem.id,
                        method: "View",
                        quotationNumber: listItem.quotation_number,
                      }}
                    >
                      <button className="p-1 w-20 rounded-md ring-1 ring-slate-600 text-sm">
                        View
                      </button>
                    </Link>
                  ) : checkAccess("Quotation", "quotation-cost-sheet-create") &&
                    checkAccess("Quotation", "quotation-cost-sheet-list") &&
                    listItem.quotation_cost_sheet_cost_detail.length <= 0 ? (
                    // &&
                    // l?.quotation_type?.name !== "Hourly"
                    <Link
                      to={`/dashboard/quotation/${listItem.id}`}
                      state={{
                        quotationId: listItem.id,
                        method: "Create",
                      }}
                    >
                      <button className="p-1 w-20 rounded-md ring-1 ring-slate-600 text-sm">
                        Create
                      </button>
                    </Link>
                  ) : (
                    <p>--</p>
                  )}
                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={listItem?.user?.name || "-"}
                    />
                  </p>
                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={
                        String(listItem.created_at).split("T")[0] || "-"
                      }
                    />
                  </p>
                  <div>
                    {checkAccess("Contract", "contract-list") &&
                    listItem?.contract?.length > 0 ? (
                      <Link
                        to={`/dashboard/contract/${listItem.contract[0].id}`}
                      >
                        <button
                          className="p-1 w-fit rounded-md ring-1 ring-slate-600 text-sm"
                          onClick={() =>
                            contractModalHandler(
                              listItem?.id,
                              listItem?.quotation_number,
                              listItem?.name
                            )
                          }
                        >
                          View Contract
                        </button>
                      </Link>
                    ) : checkAccess("Contract", "contract-create") &&
                      listItem?.status === "Approved" &&
                      listItem?.quotation_cost_sheet_cost_detail?.length > 0 ? (
                      <button
                        className="p-1 w-fit rounded-md ring-1 ring-slate-600 text-sm "
                        onClick={() =>
                          contractModalHandler(
                            listItem?.id,
                            listItem?.quotation_number,
                            listItem?.name
                          )
                        }
                      >
                        Create Contract
                      </button>
                    ) : listItem?.quotation_cost_sheet_cost_detail?.length <=
                      0 ? (
                      <p className="text-xs text-slate-500 opacity-90 font-semibold text-center w-fit">
                        CREATE COST SHEET
                      </p>
                    ) : (
                      listItem?.status !== "Approved" && (
                        <p className="text-xs text-slate-500 opacity-90 font-semibold text-center w-fit">
                          APPROVE QUOTATION
                        </p>
                      )
                    )}
                  </div>

                  <div className="flex gap-3 min-w-fit">
                    {checkAccess("Quotation", "quotation-edit") ? (
                      <button
                        className="p-1 px-2 rounded-md ring-1 ring-slate-600"
                        onClick={() => editData(listItem.id)}
                        disabled={loading.edit}
                      >
                        {loading.edit && loading.loadingId === listItem.id ? (
                          <CgSpinner className="animate-spin mx-auto" />
                        ) : (
                          <CiEdit size={"1.4rem"} />
                        )}
                      </button>
                    ) : (
                      <p>--</p>
                    )}
                    {checkAccess("Quotation", "quotation-delete") ? (
                      <button
                        className="p-1 px-2 rounded-md ring-1 ring-red text-white bg-red"
                        onClick={() =>
                          deleteData((oldState) => ({
                            open: true,
                            id: listItem.id,
                          }))
                        }
                        disabled={loading.delete}
                      >
                        {loading.delete && loading.loadingId === listItem.id ? (
                          <CgSpinner className="animate-spin mx-auto" />
                        ) : (
                          <MdDeleteOutline size={"1.4rem"} />
                        )}
                      </button>
                    ) : (
                      <p>--</p>
                    )}
                  </div>

                  <hr className="border-[1.5px] border-slate-100 w-full col-span-11" />
                </React.Fragment>
              ))}
          </div>
        </div>

        <Pagination />
      </div>
    </>
  );
}
